<template>
  <v-card>
    <v-card-title>{{title}}</v-card-title>
    <v-card-text>
      <RightsConceptsMultipleUsersAutocomplete
        :organizationUsers="organizationUsers"
        :concepts="concepts"
        v-on:addUsersToConcepts="add"
        v-on:removeUsersToConcepts="remove"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import RightsConceptsMultipleUsersAutocomplete from "@/components/Access/Rights/RightsConceptsMultipleUsersAutocomplete";

export default {
  components: { RightsConceptsMultipleUsersAutocomplete },
  props: {
    title: { type: String },
    organizationUsers: { type: Array },
    concepts: { type: Array },
  },
  data: () => {
    return {};
  },
  computed: {},
  methods: {
    add(users, concepts, rights) {
      this.$emit("add", users, concepts, rights);
    },
    remove(users, concepts, rights) {
      this.$emit("remove", users, concepts, rights);
    },
  },
};
</script>

<style>
</style>